// Generated by CoffeeScript 2.7.0
var GraphConfig, SECURITY_MODE;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import PhaseFieldsEditorModal from 'trunks/vue/admin/components/modals/phase_fields_editor_modal.js';

import BusinessTimeConfig from 'trunks/vue/admin/components/yet_another_workflow/_business_time.js';

import PopoverFieldSelect from 'trunks/vue/admin/components/popover_field_select.js';

import TimeSpan from 'trunks/vue/admin/components/time_span.js';

SECURITY_MODE = ['public', 'private'];

export default GraphConfig = {
  components: {
    'dropdown-select': DropdownSelect,
    'popover-field-select': PopoverFieldSelect,
    'time-span': TimeSpan,
    'business-time-comp': BusinessTimeConfig
  },
  props: {
    element: {
      type: Skylark.App.Model.YetAnotherWorkflow.Graph,
      required: true
    },
    allowedSecurityMode: {
      default: function() {
        return SECURITY_MODE;
      }
    }
  },
  computed: {
    graph: function() {
      return this.element;
    },
    isRootGraph: function() {
      return !(this.graph && this.graph.parent);
    }
  },
  data: function() {
    var threshold;
    threshold = (this.element && this.element.settings && this.element.settings.duration_threshold) || {};
    return {
      duration: threshold.value || '',
      business_time_enabled: threshold.enable_business_time,
      business_time: threshold.business_time
    };
  },
  template: `<div class="config-container">
  <div class="config-title">流程属性</div>
  <div class="config-item" v-if='!isRootGraph'>
    <div class="config-item-content">
      <div class="list settings-list">
        <div class="list-item">
          <div class="tip">流程名称</div>
          <div class="content">
            <input type="text" v-model.trim='graph.name' placeholder='流程' />
          </div>
        </div>
        <div class="list-item">
          <div class="tip">保密性</div>
          <div class="content">
            <dropdown-select :optionGroups="[{ options: allowedSecurityMode }]"
                             customClass='transparent'
                             :initValue='graph.settings.visibility || allowedSecurityMode[0]'
                             @change="securityChangedFunc">
              <template slot='value-template' slot-scope='{ option }'>
                <span>{{ Skylark.Helpers.getZH_CN('assignment.security.' + option) }}</span>
              </template>
              <template slot='option-template' slot-scope='{ option }'>
                <span>{{ Skylark.Helpers.getZH_CN('assignment.security.' + option) }}</span>
              </template>
            </dropdown-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="config-item">
    <div class="config-item-title justify-box">
      <span class="content text-ellipsis">流程处理时限</span>
    </div>
    <div class="config-item-content">
      <div class="list settings-list">
        <div class="list-item">
          <div class="tip force-no-wrap">手动设置处理时限</div>
          <div class="content">
            <label class="switch small">
              <input type="checkbox" v-model='graph.settings.duration_threshold.enable_manual'>
              <span></span>
            </label>
          </div>
        </div>
        <div class="list-item">
          <div class="tip force-no-wrap">时长限制</div>
          <time-span customClass='content'
                     :duration='duration'
                     ref='timespanRef'
                     @valueChanged='updateDurationThresholdFunc' />
        </div>
        <div class="list-item">
          <div class="tip">申请延时</div>
          <div class="content">
            <label class="small switch">
              <input type="checkbox" hidden='true' v-model='graph.settings.duration_threshold.enable_delay' />
              <span></span>
            </label>
          </div>
        </div>
        <div class="list-item business-time-setting">
          <span class="tip text-ellipsis">工作时间</span>
          <label class="content switch small">
            <input type="checkbox" hidden='true'
                   :checked='business_time_enabled'
                   @change='toggleBusinessTimeEnabled'>
              <span></span>
          </label>
        </div>
        <business-time-comp v-show='business_time_enabled'
                            :initValue='business_time'
                            ref='businessTimeRef'
                            @valueChanged='updateBusinessTimeFunc' />
      </div>
    </div>
  </div>
  <div class="config-item">
    <div class="config-item-title justify-box">
      <span class='content text-ellipsis'>回传字段</span>
      <div class="config-item-actions">
        <i class="slp-plus" @click='openFieldsEditModal'></i>
      </div>
    </div>
    <div class="config-item-content">
      <div class="list config-fields">
        <div class="list-item"
             v-for='field in graph.fields'
             :key='field.id'
             v-if='!field._destroy'>
          <div class="content text-ellipsis">
            <i :class="_fieldIcon(field)"></i>
            <span>{{ field.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  watch: {
    'graph.name': function() {
      return this.updateGraph();
    },
    'graph': function() {
      return this._reset();
    },
    'graph.settings.duration_threshold.enable_manual': function() {
      return this.updateGraph();
    },
    'graph.settings.duration_threshold.enable_delay': function() {
      return this.updateGraph();
    }
  },
  methods: {
    openFieldsEditModal: function() {
      var modal;
      modal = new PhaseFieldsEditorModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('modal_container'),
        propsData: {
          phase: this.graph
        }
      });
      return modal.$on('save', () => {
        return this.graph.update();
      });
    },
    securityChangedFunc: function(option) {
      this.graph.settings.visibility = option;
      return this.updateGraph();
    },
    updateDurationThresholdFunc: function(value) {
      this.duration = value;
      this.graph.settings.duration_threshold.value = this.duration;
      return this.updateGraph();
    },
    toggleBusinessTimeEnabled: function() {
      this.business_time_enabled = !this.business_time_enabled;
      return this.updateBusinessTimeFunc(this.business_time);
    },
    updateBusinessTimeFunc: function(value) {
      this.graph.settings.duration_threshold.enable_business_time = this.business_time_enabled;
      this.business_time = value;
      this.graph.settings.duration_threshold.business_time = this.business_time;
      return this.updateGraph();
    },
    updateGraph: _.debounce(function() {
      return this.graph.update();
    }, 1000),
    _reset: function() {
      var threshold;
      threshold = (this.element && this.element.settings && this.element.settings.duration_threshold) || {};
      this.duration = threshold.value || '';
      this.business_time_enabled = threshold.enable_business_time;
      this.business_time = threshold.business_time;
      return this.$nextTick(function() {
        this.$refs.timespanRef.reset();
        return this.$refs.businessTimeRef.reset();
      });
    },
    _fieldIcon: function(field) {
      return field.getTypeIcon();
    }
  }
};
